import { render, staticRenderFns } from "./MarkingList.vue?vue&type=template&id=4aab2f0e&scoped=true"
import script from "./MarkingList.vue?vue&type=script&lang=js"
export * from "./MarkingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@1.0.1_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab2f0e",
  null
  
)

export default component.exports